import { defineMessages } from 'react-intl';

export default defineMessages({
  firstNamePlaceholder: {
    id: 'yourProfileForm.firstNamePlaceholder',
    defaultMessage: 'First name',
  },
  lastNamePlaceholder: {
    id: 'yourProfileForm.lastNamePlaceholder',
    defaultMessage: 'Last name',
  },
  emailPlaceholder: {
    id: 'yourProfileForm.emailPlaceholder',
    defaultMessage: 'Email address',
  },
  phoneNumberPlaceholder: {
    id: 'yourProfileForm.phoneNumberPlaceholder',
    defaultMessage: 'e.g +44 7515737293',
  },
  phoneNumberLabel: {
    id: 'yourProfileForm.phoneNumberLabel',
    defaultMessage: 'Phone number',
  },
  agreementPlaceholder: {
    id: 'yourProfileForm.agreementPlaceholder',
    defaultMessage: 'I consent to receiving inspiration, special offers and policy updates via email',
  },
  submitButton: {
    id: 'yourProfileForm.submitButton',
    defaultMessage: 'Update',
  },
  fieldRequired: {
    id: 'yourProfileForm.fieldRequired',
    defaultMessage: 'This field is required',
  },
  incorrectEmailFormat: {
    id: 'yourProfileForm.incorrectEmailFormat',
    defaultMessage: 'This is not a valid e-mail format',
  },
  incorrectPhoneNumberFormat: {
    id: 'yourProfileForm.incorrectPhoneNumberFormat',
    defaultMessage: 'This is not a valid phone number format',
  },
});
